import { render } from "./WorkorderIndex.vue?vue&type=template&id=dd1a7e60"
import script from "./WorkorderIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkorderIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Workorder/WorkorderIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "dd1a7e60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('dd1a7e60', __exports__)) {
    api.reload('dd1a7e60', __exports__)
  }
  
  module.hot.accept("./WorkorderIndex.vue?vue&type=template&id=dd1a7e60", () => {
    api.rerender('dd1a7e60', render)
  })

}


export default __exports__